const BaseURL = "https://rastrack-api.compgovpartners.com/api/";
// const BaseURL = "https://dev-cgp.upworkdeveloper.com/api/";

const Endpoint = {
  auth: {
    login: "login",
    resetPassword: "reset-password",
    forgotPassword: "forgotPassword",
    logout: "logout",
  },
  user: {
    get: "user/get",
    update: "user/update",
    changePassword: "user/changePassword",
  },
  questionnaire: {
    getLevelOfWorkDropdowns: "questions/dropdowns",
    getAllDropdownsWithOptions: "questions/dropdown-options",
    getAppOutComes: "questions/app-outcomes",
    getQuestions: "questions/getQuestions",
  },
  evaluations: {
    addEvaluation: "evaluation/addEvaluations",
    checkJobCode: "evaluation/checkSingleJobCode",
    addDraftEvaluation: "evaluation/addDraft",
    updateDraftEvaluation: "evaluation/editDraft/:id",
    getAllEvaluation: "evaluation/listEvaluations",
    activateEvaluation: "evaluation/activateEvaluation/:id",
    deActivateEvaluation: "evaluation/deactivateEvaluation/:id",
    activateEvaluationVersion: "evaluation/activateEvaluationVersion/:id",
    archiveVersion: "evaluation/archiveEvaluations",
    unArchiveVersion: "evaluation/unarchiveEvaluations",
    flagEvaluations: "evaluation/flagEvaluation/:id",
    unFlagEvaluations: "evaluation/unflagEvaluation/:id",
    getDraftEvaluations: "evaluation/listDrafts",
    getFlagEvaluations: "evaluation/listFlaggedEvaluations",
    getCGPEvaluations: "evaluation/listCGPEvaluations",
    addRequest: "evaluation/addEvaluationRequests",
    getArchivedEvaluations: "evaluation/listArchivedEvaluations",
    getSingleEvaluation: "evaluation/singleEvaluationVersions/:id",
    deleteEvaluationVersion: "evaluation/version/:id",
    getCurrentVersionDetails: "evaluation/getVersionDetails/:id",
    approveEvaluation: "evaluation/approveCGPEvaluation/:id",
    updateEvaluation: "evaluation/updateEvaluation/:id",
    completeDraft: "evaluation/completeDraft/:id",
    archiveCount: "evaluation/evaluationsCount",
    download: "evaluation/downloadEvaluations",
    downloadAll: "evaluation/downloadAllEvaluations",
  },
  general: {
    stats: "stats/dashboard",
    listUsers: "listings/users",
    listOptions: "listings/options",
    contactus: "addSupportMessage",
  },
  notifications: {
    get: "notification/listNotifications",
    readAll: "notification/markAllAsRead",
    count: "notification/notificationCount",
  },
};

export { Endpoint, BaseURL };
